module.exports = __webpack_public_path__ + "static/media/sensor.c55176bd.svg";